/*
 * Author: Dicky Dichandra / Pacdev
 * Copyright (c) 2022 Optikultur Indonesia
 */

import { useFilePicker } from 'use-file-picker'
import { Box, Button, Container, Typography } from '@mui/material'
import FileUploadIcon from '@mui/icons-material/FileUpload'

export default function FileSelector() {
    const [openFileSelector, { filesContent, loading }] = useFilePicker({
        accept: '.jpg .png',
    })

    if (loading) {
        return <Typography>Loading...</Typography>
    }

    return (
        <>
            <Button
                onClick={() => openFileSelector()}
                variant="outlined"
                component="label"
                sx={{ gap: '.5em' }}
            >
                <FileUploadIcon />
                Upload File
            </Button>
            {filesContent.map((file, index) => (
                <Typography>{file.name}</Typography>
            ))}
        </>
    )
}
